module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.carregou) ? _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('box', {
    attrs: {
      "title": "Dados do Cliente"
    }
  }, [_c('div', {
    staticClass: "bodyBox",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Cliente: ")]), _vm._v(" " + _vm._s(_vm.solicitacao.Clientes.nome) + " " + _vm._s(_vm.solicitacao.Clientes.sobrenome) + " "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Email: ")]), _vm._v(" " + _vm._s(_vm.solicitacao.Clientes.email) + " "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Contato: ")]), _vm._v(" " + _vm._s(_vm.solicitacao.Clientes.contato) + " "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Preferência de contato: ")]), _vm._v(" " + _vm._s(_vm.solicitacao.Preferencias[0].tipo) + " "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Horário para contato: ")]), _vm._v(" " + _vm._s(_vm.solicitacao.Preferencias[0].horario) + " "), _c('br')])])])], 1)]), _vm._v(" "), (_vm.solicitacao.tipo === 'personalizado') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('box', {
    attrs: {
      "title": "Interesses"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, _vm._l((_vm.solicitacao.SolicitacoesHasFiltros), function(pergunta) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "1em",
        "display": "flex"
      }
    }, [_c('label', {
      attrs: {
        "for": ""
      }
    }, [_vm._v(_vm._s(pergunta.Filtros.descricao) + ": ")]), _c('h4', {
      staticClass: "resposta"
    }, [_vm._v(_vm._s(pergunta.filtrosid === _vm.solicitacao.RespostasAdicionais[0].filtrosid ? ((pergunta.resposta) + " (" + (_vm.solicitacao.RespostasAdicionais[0].resposta) + ")") : pergunta.resposta) + " ")])])
  }), 0)])], 1)]) : _vm._e(), _vm._v(" "), (_vm.solicitacao.tipo === 'pacote') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('box', {
    attrs: {
      "title": "Pacote de Viagem"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example2_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunas), function(coluna) {
    return _c('th', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                    " + _vm._s(coluna) + "\n                                    ")])])])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.solicitacao.Pacotes.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pacotes.titulo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pacotes.descricao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pacotes.qtdepessoas))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pacotes.preco))])])]), _vm._v(" "), _c('tfoot')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.solicitacao.tipo === 'pacote') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('box', {
    attrs: {
      "title": "Dados Pagamento"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example2_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunasPgto), function(coluna) {
    return _c('th', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                    " + _vm._s(coluna) + "\n                                    ")])])])
  }), 0)]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.solicitacao.Pagamentos[0].nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pagamentos[0].numero))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pagamentos[0].vencimento))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.solicitacao.Pagamentos[0].codigo))])])]), _vm._v(" "), _c('tfoot')])])])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.solicitacao.tipo === 'pacote') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('box', {
    attrs: {
      "title": "Dados Passageiros"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-borde#F48668 table-striped dataTable",
    attrs: {
      "aria-describedby": "example2_info",
      "role": "grid",
      "id": "example2"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.colunasPassageiros), function(coluna) {
    return _c('th', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-7"
    }, [_vm._v("\n                                    " + _vm._s(coluna) + "\n                                    ")])])])
  }), 0)]), _vm._v(" "), _c('tbody', _vm._l((_vm.solicitacao.DadosPassageiros), function(passageiro) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(passageiro.nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(passageiro.cpf))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(passageiro.contato))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(passageiro.email))])])
  }), 0), _vm._v(" "), _c('tfoot')])])])])], 1)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ef79b60"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Solicitacoes/detalhe.vue
// module id = 1204
// module chunks = 1